import styled from 'styled-components'
import {Flex} from '../../../App/Components/Container/Flex'

export const ProfileHead = styled(Flex)`
    z-index: 8;
`

export const ProfileAvatar = styled.img`
    width: 8em;
    height: 8em;
    border-radius: 50%;
    margin-right: 2em;
    margin-left: 1em;
`
